// extracted by mini-css-extract-plugin
export default {"previewPhoto":"PreviewPhoto_previewPhoto__U7zNo","photo":"PreviewPhoto_photo__ua6B+"};